import { COLORS } from '@/utils/static';
import { MinusOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Collapse } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { Flex } from '@/ui';
import { UpdateProductDescriptionModal } from '@/components';

export const CollapseList = ({ items, productDescriptions, adminView = false, onDelete }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const genExtra = useCallback(
    (item) => (
      <Flex gap={15} align={'center'} style={{ fontSize: '16px' }}>
        <EditOutlined
          onClick={(event) => {
            event.stopPropagation();
            setSelectedItem(item);
            setIsOpenModal(true);
          }}
        />
        <DeleteOutlined
          onClick={(event) => {
            event.stopPropagation();
            onDelete(item.key);
          }}
        />
      </Flex>
    ),
    [onDelete]
  );

  const finalItems = useMemo(() => {
    if (!adminView) {
      return items;
    } else {
      return items.map((item) => ({
        ...item,
        extra: genExtra(item)
      }));
    }
  }, [adminView, genExtra, items]);

  return (
    <>
      <StyledCollapse
        ghost
        expandIcon={({ isActive }) => (isActive ? <MinusOutlined /> : <PlusOutlined />)}
        expandIconPosition={adminView ? 'start' : 'end'}
        items={finalItems}
      />
      <UpdateProductDescriptionModal
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        selectedItem={selectedItem}
        productDescriptions={productDescriptions}
      />
    </>
  );
};

const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    font-weight: 600;
    background: transparent !important;
    padding: 16px 0 !important;
  }
  .ant-collapse-item {
    border: none !important;
    font-size: 15px;

    &:not(:last-child) {
      border-bottom: 1px solid ${COLORS.greyBasic} !important;
    }
  }
  .ant-collapse-content-box {
    padding: 0 0 16px !important;

    p {
      margin: 0;
      color: ${COLORS.greyText};
    }
  }
`;
